import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import DragDropFileUpload from '../../../CommonComponents/DragDropFileUpload'
import { Panel } from 'rsuite';
import ThreeStateToggleButton from '../../../CommonComponents/ThreeStateToggleButton'
import { checkIsEmailValid, generateAchAcceptanceChangeLog } from '../../../../services/helper'
import { Loader } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { updateSupplierPaymentInfo, uploadAchInstruction, addSupplierHistory } from '../../../../redux/actions/vendor'
import { toast } from '../../../CommonComponents/ToastComponent/toast'

const AchInfo = ({ achInfo, selectedAchInfo, onFieldClick, onChangeAchInfo, handleAchEmailFocusOut, isEmailValid, isValidatingEmail, onChangeAchInstructionFile, achInstructionFile }) => {
    const supplier_types = ['related', 'master'];
    const handleEmailAchFocusOut = (emailValue) => {
        handleAchEmailFocusOut(emailValue, 'ach')
    }

    const handleFileChosen = (file) => {
        if (
            !file
        ) {
            return
        }
        onChangeAchInstructionFile(file, 'ach')
    }

    return (
        <div className="card supply-ach-acceptance related-supply-ach-acceptance">
            <div className="card-content d-flex flex-column flex-lg-row gap-4 gap-sm-5">
                {supplier_types.map((value, index) => (
                    <div key={index} className={`${value}-supplier-card-content w-auto`}>
                        {/* <div className="item flex-wrap">
                            <h3 className='supplier-card-content-header text-black fw-bold pt-3 pb-3'> {value === 'related' ? 'Related Supplier Information' : isLocationBasedMaster ? 'Location-Based Master Supplier Information' : 'Master Supplier Information'} </h3>
                            {isLocationMasterEditable && value === 'master' && (
                                <div className='ms-auto'>
                                    <button type="button" className="card-edit-button me-0 p-2 ps-3 pe-3 ps-sm-4 pe-sm-4 me-2 bg-light-gray text-white rounded width-100" onClick={handleClickCancel}>Cancel</button>
                                    {isValidatingMasterEmail ? (
                                        <button type="button" className="card-edit-button me-0 p-2 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green rounded">Validating...</button>
                                    ) : (
                                        <button type="button" className="card-edit-button me-0 p-2 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green rounded width-100" onClick={handleClickSave} disabled={hasError}>Save</button>
                                    )}
                                </div>
                            )}
                        </div> */}
                        <div className="item" onClick={() => { value === 'related' && onFieldClick('isAcceptAchPayments', achInfo?.['isAcceptAchPayments']) }}>
                            <h4 className='fw-bold text-black toggle-item-text'>Do they accept ACH Payments?</h4>
                            <ThreeStateToggleButton
                                checked={value === 'related' ? achInfo?.isAcceptAchPayments : selectedAchInfo?.isAcceptAchPayments}
                                isDisabled={value === 'related' ? true : false}
                                onChange={(checked) => { value !== 'related' && onChangeAchInfo('isAcceptAchPayments', checked) }}
                            />
                        </div>
                        {
                            (value === 'related' ? achInfo?.isAcceptAchPayments : selectedAchInfo?.isAcceptAchPayments) && (
                                <>
                                    <div className="item flex-wrap flex-sm-nowrap">
                                        <h4 className='item-name flex-grow-1 flex-sm-grow-0'>Bank Name:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? achInfo?.bankName || '' : selectedAchInfo?.bankName || ''}
                                            readOnly={value === 'related' ? true : false}
                                            onClick={() => { value === 'related' && onFieldClick('bankName', achInfo?.['bankName']) }}
                                            onChange={(e) => { value !== 'related' && onChangeAchInfo('bankName', e.target.value) }}
                                        />
                                    </div>
                                    <div className="item flex-wrap flex-sm-nowrap">
                                        <h4 className='item-name flex-grow-1 flex-sm-grow-0'>Bank Account Number:</h4>
                                        <input
                                            type="text"
                                            className="search-input"
                                            value={value === 'related' ? achInfo?.bankAccountNumber || '' : selectedAchInfo?.bankAccountNumber || ''}
                                            readOnly={value === 'related' ? true : false}
                                            onClick={() => { value === 'related' && onFieldClick('bankAccountNumber', achInfo?.['bankAccountNumber']) }}
                                            onChange={(e) => { value !== 'related' && onChangeAchInfo('bankAccountNumber', e.target.value) }}
                                        />
                                    </div>
                                    <div className="item flex-wrap flex-sm-nowrap">
                                        <h4 className='item-name flex-grow-1 flex-sm-grow-0'>Bank Routing Number:</h4>
                                        <input
                                            type="text"
                                            className={`search-input ${value === 'master' && selectedAchInfo.isAcceptAchPayments && !/^\d{9}$/.test(selectedAchInfo.bankRoutingNumber) && 'error-border'}`}
                                            value={value === 'related' ? achInfo?.bankRoutingNumber || '' : selectedAchInfo?.bankRoutingNumber || ''}
                                            readOnly={value === 'related' ? true : false}
                                            onClick={() => { value === 'related' && onFieldClick('bankRoutingNumber', achInfo?.['bankRoutingNumber']) }}
                                            onChange={(e) => { value !== 'related' && onChangeAchInfo('bankRoutingNumber', e.target.value) }}
                                        />
                                    </div>
                                    <div className="item flex-column ach-instructions">
                                        <h4 className='item-name flex-grow-1 flex-sm-grow-0'>ACH Instructions:</h4>
                                        <div className="accept-item" onClick={() => {
                                            value === 'related' && onFieldClick('achInstructions', achInfo?.['achInstructions'])
                                        }}>
                                            <DragDropFileUpload
                                                currentFileName={value === 'related' ? achInfo?.achInstructions || '' : achInstructionFile ? achInstructionFile?.name : selectedAchInfo?.achInstructions || ''}
                                                customClassName='upload-vendor-file'
                                                accept='*.*'
                                                isDisabled={value === 'related' ? true : false}
                                                onFileChosen={value === 'master' && handleFileChosen}
                                                isDownload={value === 'related' ? false : (selectedAchInfo?.achInstructions && selectedAchInfo?.achInstructions !== '' && selectedAchInfo?.achInstructions !== null && achInstructionFile === null) ? true : false}
                                            />
                                        </div>
                                    </div>
                                    <div className="item flex-wrap flex-sm-nowrap">
                                        <h4 className='item-name flex-grow-1 flex-sm-grow-0'>Email Address for payment notification:</h4>
                                        <div className='d-flex flex-grow-1 align-items-center gap-2 w-100'>
                                            <input
                                                type="text"
                                                className={`search-input ${value === 'master' && selectedAchInfo.emailAch && selectedAchInfo.emailAch !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(selectedAchInfo.emailAch) && 'error-border'}`}
                                                value={value === 'related' ? achInfo?.emailAch || '' : selectedAchInfo?.emailAch || ''}
                                                readOnly={value === 'related' ? true : false}
                                                onClick={() => { value === 'related' && onFieldClick('emailAch', achInfo?.['emailAch']) }}
                                                onChange={(e) => { value !== 'related' && onChangeAchInfo('emailAch', e.target.value) }}
                                                onBlur={() => { value !== 'related' && handleEmailAchFocusOut(selectedAchInfo?.emailAch || '') }}
                                            />
                                            {(value !== 'related' && isValidatingEmail) && (<Loader />)}
                                            {(value !== 'related' && (selectedAchInfo?.emailAch && !isValidatingEmail && isEmailValid !== '')) &&
                                                ((value !== 'related' && isEmailValid) ?
                                                    <BsCheckSquare color="#067911" size={26} />
                                                    :
                                                    <BsXSquare color="#f75a52" size={26} />
                                                )
                                            }
                                        </div>
                                    </div>
                                </>
                            )
                        }
                        {(index === 0 && <hr className='d-block d-lg-none' />)}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AchInfo